import { IRegLookupResults, IRegLookupServerResponse } from "./results.model";
import { RegLookupControl } from "../reg-lookup-control.model";
import { ApiRequestOptions } from "../../../../core/services/api/request-options";
import { VasAppFacade } from "../../../services/vas-app-facade.service";

export class RegLookupRequest {

    protected accountId: string;
    protected externalLookup: string;

    constructor(protected appFacade: VasAppFacade,
                protected control: RegLookupControl,
                protected registration: string) {

        this.accountId = this.control.account;
        this.externalLookup = this.control.config.externalLookup;
    }

    getResult(): Promise<IRegLookupResults> {

        if (!this.externalLookup) {
            return Promise.reject({});
        }

        return this.appFacade.api.simpleGet(this.getUrl(), new ApiRequestOptions({
            query: this.getQuery()
        }))
            .map(response => response.json())
            .map((response: IRegLookupServerResponse) => response.output)
            .toPromise();
    }

    protected getAccountId(): string {
        return this.accountId;
    }

    protected getProvider(): string {
        return this.externalLookup;
    }

    protected getRegistration(): string {
        return this.registration.replace(/ /, "");
    }

    getUrl(): string {
        return `/accounts/${this.getAccountId()}/externallookups/${this.getProvider()}/lookup`;
    }

    protected getControlId(): string {
        return this.control.id;
    }

    protected getControlName(): string {
        return this.control.name;
    }

    protected getQuery(): object {
        return {
            q: {
                input: {
                    [this.getControlName()]: this.getRegistration()
                }
            }
        };
    }

    protected getResultsMock(): Promise<IRegLookupResults> {
        console.log("performing mock lookup with options:", this.getUrl());
        return new Promise((resolve, reject) => {
            setTimeout(() => {
                resolve({
                    "fields.registration": [
                        {label: "", value: "XXX 123"}
                    ],
                    "fields.make": [
                        {label: "", value: "Audi"}
                    ],
                    "fields.model": [
                        {label: "", value: "A3"}
                    ],
                    "fields.colour": [
                        {label: "", value: "Blue"}
                    ],
                    "fields.finish": [
                        {label: "", value: "Metallic"}
                    ],
                    "fields.derivative": [
                        {label: "", value: "SE TDI"}
                    ],
                    "fields.bodyStyle": [
                        {label: "", value: "Hatchback"}
                    ],
                    "fields.doors": [
                        {label: "", value: "3"}
                    ],
                    "fields.fuelType": [
                        {label: "", value: "Diesel"}
                    ],
                    "fields.transmission": [
                        {label: "", value: "Manual"}
                    ],
                    "fields.engineSize": [
                        {label: "", value: "1968"}
                    ],
                    "fields.vin": [
                        {label: "", value: "12345678910"}
                    ],
                    "fields.firstRegistration": [
                        {label: "First Registration", value: "2016-01-01"},
                        {label: "V5C Date", value: "2017-01-01"}
                    ],
                    "fields.steeringPosition": [
                        {label: "", value: "RIGHT"}
                    ]
                });
            }, 1000);
        });
    }
}



// WEBPACK FOOTER //
// ./src/vas/controls/reglookup/form/request.model.ts